"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.userClientIsLoadingSelector = exports.userClientErrorSelector = exports.userClientMetadataSelector = exports.userClientSettingsSelector = exports.userClientDataSelector = void 0;

var _reselect = require("reselect");

var clientSelector = function clientSelector(state) {
  return state.client;
};

var userClientSelector = (0, _reselect.createSelector)(clientSelector, function (client) {
  return client.userClient;
});
var userClientDataSelector = (0, _reselect.createSelector)(userClientSelector, function (userClient) {
  return userClient === null || userClient === void 0 ? void 0 : userClient.data;
});
exports.userClientDataSelector = userClientDataSelector;
var userClientSettingsSelector = (0, _reselect.createSelector)(userClientDataSelector, function (userData) {
  return userData === null || userData === void 0 ? void 0 : userData.settings;
});
exports.userClientSettingsSelector = userClientSettingsSelector;
var userClientMetadataSelector = (0, _reselect.createSelector)(userClientDataSelector, function (userData) {
  var _userData$information;

  return (userData === null || userData === void 0 ? void 0 : (_userData$information = userData.information) === null || _userData$information === void 0 ? void 0 : _userData$information.metadata) || {};
});
exports.userClientMetadataSelector = userClientMetadataSelector;
var userClientErrorSelector = (0, _reselect.createSelector)(userClientSelector, function (client) {
  return client.error;
});
exports.userClientErrorSelector = userClientErrorSelector;
var userClientIsLoadingSelector = (0, _reselect.createSelector)(userClientSelector, function (client) {
  return client.isLoading;
});
exports.userClientIsLoadingSelector = userClientIsLoadingSelector;
var _default = {
  userClientDataSelector: userClientDataSelector,
  userClientSettingsSelector: userClientSettingsSelector,
  userClientMetadataSelector: userClientMetadataSelector,
  userClientErrorSelector: userClientErrorSelector,
  userClientIsLoadingSelector: userClientIsLoadingSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map